/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PAC API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DomainErrorDto,
  SetUserPermissionsRequestDto,
  UserPermissionDetailsResponseDto,
  UserPermissionsResponseDto
} from './pacApi.schemas';

import { axios } from '../../common/axios';
import type { ErrorType , BodyType } from '../../common/axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const permissionsControllerGetMyPermissions = (

 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<UserPermissionsResponseDto>(
      {url: `/api/v1/me/permissions`, method: 'GET', signal
    },
      options);
    }




export const getPermissionsControllerGetMyPermissionsQueryKey = () => {
    return [
    `/api/v1/me/permissions`
    ] as const;
    }


export const getPermissionsControllerGetMyPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsControllerGetMyPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>> = ({ signal }) => permissionsControllerGetMyPermissions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsControllerGetMyPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>>
export type PermissionsControllerGetMyPermissionsQueryError = ErrorType<DomainErrorDto>


export function usePermissionsControllerGetMyPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>,
          TError,
          Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetMyPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>,
          TError,
          Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetMyPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsControllerGetMyPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsControllerGetMyPermissionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPermissionsControllerGetMyPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsControllerGetMyPermissionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>> = ({ signal }) => permissionsControllerGetMyPermissions(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsControllerGetMyPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>>
export type PermissionsControllerGetMyPermissionsSuspenseQueryError = ErrorType<DomainErrorDto>


export function usePermissionsControllerGetMyPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetMyPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetMyPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsControllerGetMyPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError = ErrorType<DomainErrorDto>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetMyPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsControllerGetMyPermissionsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const permissionsControllerGetUserPermissions = (
    userId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<UserPermissionsResponseDto>(
      {url: `/api/v1/users/${userId}/permissions`, method: 'GET', signal
    },
      options);
    }




export const getPermissionsControllerGetUserPermissionsQueryKey = (userId: string,) => {
    return [
    `/api/v1/users/${userId}/permissions`
    ] as const;
    }


export const getPermissionsControllerGetUserPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsControllerGetUserPermissionsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>> = ({ signal }) => permissionsControllerGetUserPermissions(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsControllerGetUserPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>>
export type PermissionsControllerGetUserPermissionsQueryError = ErrorType<DomainErrorDto>


export function usePermissionsControllerGetUserPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>,
          TError,
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>,
          TError,
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsControllerGetUserPermissions<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsControllerGetUserPermissionsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPermissionsControllerGetUserPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsControllerGetUserPermissionsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>> = ({ signal }) => permissionsControllerGetUserPermissions(userId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsControllerGetUserPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>>
export type PermissionsControllerGetUserPermissionsSuspenseQueryError = ErrorType<DomainErrorDto>


export function usePermissionsControllerGetUserPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsControllerGetUserPermissionsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissions>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsControllerGetUserPermissionsSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const permissionsControllerSetUserPermissions = (
    userId: string,
    setUserPermissionsRequestDto: BodyType<SetUserPermissionsRequestDto>,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<UserPermissionsResponseDto>(
      {url: `/api/v1/users/${userId}/permissions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setUserPermissionsRequestDto, signal
    },
      options);
    }



export const getPermissionsControllerSetUserPermissionsMutationOptions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof permissionsControllerSetUserPermissions>>, TError,{userId: string;data: BodyType<SetUserPermissionsRequestDto>}, TContext>, request?: SecondParameter<typeof axios>}
): UseMutationOptions<Awaited<ReturnType<typeof permissionsControllerSetUserPermissions>>, TError,{userId: string;data: BodyType<SetUserPermissionsRequestDto>}, TContext> => {

const mutationKey = ['permissionsControllerSetUserPermissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof permissionsControllerSetUserPermissions>>, {userId: string;data: BodyType<SetUserPermissionsRequestDto>}> = (props) => {
          const {userId,data} = props ?? {};

          return  permissionsControllerSetUserPermissions(userId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PermissionsControllerSetUserPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerSetUserPermissions>>>
    export type PermissionsControllerSetUserPermissionsMutationBody = BodyType<SetUserPermissionsRequestDto>
    export type PermissionsControllerSetUserPermissionsMutationError = ErrorType<DomainErrorDto>

    export const usePermissionsControllerSetUserPermissions = <TError = ErrorType<DomainErrorDto>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof permissionsControllerSetUserPermissions>>, TError,{userId: string;data: BodyType<SetUserPermissionsRequestDto>}, TContext>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof permissionsControllerSetUserPermissions>>,
        TError,
        {userId: string;data: BodyType<SetUserPermissionsRequestDto>},
        TContext
      > => {
      return useMutation(getPermissionsControllerSetUserPermissionsMutationOptions(options), queryClient);
    }
    export const permissionsControllerGetUserPermissionDetails = (
    userId: string,
 options?: SecondParameter<typeof axios>,signal?: AbortSignal
) => {


      return axios<UserPermissionDetailsResponseDto>(
      {url: `/api/v1/users/${userId}/permissions/details`, method: 'GET', signal
    },
      options);
    }




export const getPermissionsControllerGetUserPermissionDetailsQueryKey = (userId: string,) => {
    return [
    `/api/v1/users/${userId}/permissions/details`
    ] as const;
    }


export const getPermissionsControllerGetUserPermissionDetailsQueryOptions = <TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsControllerGetUserPermissionDetailsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>> = ({ signal }) => permissionsControllerGetUserPermissionDetails(userId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsControllerGetUserPermissionDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>>
export type PermissionsControllerGetUserPermissionDetailsQueryError = ErrorType<DomainErrorDto>


export function usePermissionsControllerGetUserPermissionDetails<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>,
          TError,
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissionDetails<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>,
          TError,
          Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissionDetails<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsControllerGetUserPermissionDetails<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsControllerGetUserPermissionDetailsQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPermissionsControllerGetUserPermissionDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPermissionsControllerGetUserPermissionDetailsQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>> = ({ signal }) => permissionsControllerGetUserPermissionDetails(userId, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PermissionsControllerGetUserPermissionDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>>
export type PermissionsControllerGetUserPermissionDetailsSuspenseQueryError = ErrorType<DomainErrorDto>


export function usePermissionsControllerGetUserPermissionDetailsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissionDetailsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePermissionsControllerGetUserPermissionDetailsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePermissionsControllerGetUserPermissionDetailsSuspense<TData = Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError = ErrorType<DomainErrorDto>>(
 userId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof permissionsControllerGetUserPermissionDetails>>, TError, TData>>, request?: SecondParameter<typeof axios>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPermissionsControllerGetUserPermissionDetailsSuspenseQueryOptions(userId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






